import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EBedroomsCount } from '../../../../../../../json_query';
import { changeBedroomsCount } from '../../../../../../state/advanced/bedrooms_min_count';

import { Bedrooms as BedroomsComponent, IBedroomsProps } from './bedrooms';

type TBedroomsStateProps = Pick<IBedroomsProps, 'value'>;
type TBedroomsDispatchProps = Pick<IBedroomsProps, 'onChange'>;

export function mapStateToProps(state: IAppState): TBedroomsStateProps {
  return {
    value:
      (state.filters.jsonQuery.bedroom_total && state.filters.jsonQuery.bedroom_total.value.gte) || EBedroomsCount.Any,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): TBedroomsDispatchProps {
  return {
    onChange: (count: EBedroomsCount) => {
      dispatch(changeBedroomsCount(count));
    },
  };
}

export const Bedrooms = connect(mapStateToProps, mapDispatchToProps)(BedroomsComponent);
